<template>
    <span v-if="readonly" class="tag">
        {{ translate("discipline_packages.bracket_kata_performances_default") }}
    </span>
    <div v-else class="select">
        <select v-model.number="numberOfPerformances">
            <option v-for="n in [1, 2, 3]" :key="n" :value="n">
                {{ n }} {{ translate("discipline_packages.bracket_kata_performances_label") }}
            </option>
        </select>
    </div>
</template>

<script setup lang="ts">
    import { computed } from "vue";
    import { translate } from "../../Common/translations";
    import { KataSettings } from "../../Brackets/configurationTemplates";

    withDefaults(
        defineProps<{
            readonly?: boolean;
        }>(),
        {
            readonly: false,
        },
    );

    const settings = defineModel<KataSettings | undefined>();

    const numberOfPerformances = computed({
        get: () => settings.value?.numberOfPerformances ?? 1,
        set: (value: number) => {
            settings.value = {
                ...(settings.value ?? {}),
                numberOfPerformances: value,
            };
        },
    });
</script>
